import { Skeleton } from '@repo/videa-components/src';
import classNames from 'classnames';

interface Props {
  count: JSX.Element;
  dataTestId?: string;
  label: string;
  loading?: boolean;
  onClick: () => void;
  selected: boolean;
}

export const FilterButton = ({
  count,
  dataTestId,
  label,
  loading,
  onClick,
  selected,
}: Props) => {
  if (loading) {
    return <Skeleton className="vai-h-11" />;
  }

  return (
    <button
      className={classNames(
        'vai-cursor-pointer vai-p-2 vai-flex vai-gap-2 vai-items-center vai-justify-between vai-rounded vai-border-none vai-text-left',
        {
          'vai-bg-sapphire-100': selected,
          'vai-bg-white hover:vai-bg-gray-100': !selected,
        },
      )}
      data-selected={selected}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <p
        className={classNames('vai-typography-small', {
          '!vai-text-sapphire-700 vai-font-medium': selected,
          '!vai-text-[#0E0C31] vai-font-normal': !selected,
        })}
      >
        {label}
      </p>
      {count}
    </button>
  );
};
